import {createSlice} from '@reduxjs/toolkit';

import awsRumCustomEvents from '../../consts/aws/awsRumCustomEvents';
import storeSliceNames from '../../consts/storeSliceNames';
import helpers from '../../utils/helpers';

const initialState = {
    currentFlowParameters: {
        currentFlow: awsRumCustomEvents.DEFAULT,
    },
    pageParameters: {},
    captivePortalPage: null,
};

const monitoringSlice = createSlice({
    name: storeSliceNames.monitoring,
    initialState,
    reducers: {
        setCurrentFlow(state, action) {
            const {currentFlow, initialType, initialSource} = action.payload;

            state.currentFlowParameters = {
                currentFlow,
                eventId: helpers.guid(),
                startTime: Date.now(),
                initialType,
                initialSource,
            };
        },
        resetCurrentFlow(state) {
            state.currentFlowParameters = initialState.currentFlowParameters;
        },
        setPageParameters(state, action) {
            const {pageId, parentPageInteractionId} = action.payload;

            state.pageParameters = {pageId, parentPageInteractionId};
        },
        setCaptivePortalPage(state, action) {
            state.captivePortalPage = action.payload;
        },
    },
});

export const setCurrentFlow = (flow, params) => monitoringSlice.actions.setCurrentFlow({currentFlow: flow, ...params});

export const resetCurrentFlow = () => monitoringSlice.actions.resetCurrentFlow();

export const setPageParameters = (pageId, parentPageInteractionId) =>
    monitoringSlice.actions.setPageParameters({pageId, parentPageInteractionId});

export const setCaptivePortalPage = (page) => monitoringSlice.actions.setCaptivePortalPage(page);

export default monitoringSlice.reducer;
